import React, { Component } from 'react'
import { Select } from 'hljd'
import moment from 'moment'
import { omit } from '@hlj/hlj-utils'

const Option = Select.Option

/**
 * TODO，这个组件扩展，支持各种 format
 */
export default class extends Component {
  static defaultProps = {
    lastMonths: 6,
    style: {
      width: 160
    }
  }

  getMonthList = () => {
    const { lastMonths, lastToMonth } = this.props
    const monthList = []

    const nums = lastToMonth
      ? moment().diff(moment(lastToMonth), 'month')
      : lastMonths

    for (let i = 0; i <= nums; i++) {
      const now = moment().subtract(i, 'months')
      monthList.push({
        title: now.format('YYYY年MM月'),
        value: now.format('YYYY-MM')
      })
    }

    return monthList
  }

  render() {
    return (
      <Select
        placeholder="选择时间"
        {...omit(this.props, ['lastMonths', 'lastToMonth'])}
      >
        <Option value="">全部</Option>
        {this.getMonthList().map(({ title, value }) => {
          return (
            <Option key={value} value={value}>
              {title}
            </Option>
          )
        })}
      </Select>
    )
  }
}
